var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.4 5.4 0 12 0C18.6 0 24 5.4 24 12C24 18.6 18.6 24 12 24C5.4 24 0 18.6 0 12ZM10.7969 5.20938H13.1969V14.0094H10.7969V5.20938ZM11.9965 19.2094C12.8801 19.2094 13.5965 18.493 13.5965 17.6094C13.5965 16.7257 12.8801 16.0094 11.9965 16.0094C11.1128 16.0094 10.3965 16.7257 10.3965 17.6094C10.3965 18.493 11.1128 19.2094 11.9965 19.2094Z",
    fill: "#ED002A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatErrorIcon);
export default __webpack_public_path__ + "static/media/chatErrorIcon.a1285b1c28aeeff46bfa96afd2cbaee8.svg";
export { ForwardRef as ReactComponent };